(function initMobileNavigation() {
  var drawer = document.getElementById('mobile-drawer');
  if (!drawer || drawer.dataset.layerNavigationReady === 'true') return;

  drawer.dataset.layerNavigationReady = 'true';

  var root = drawer.querySelector('[data-mobile-nav-root]');
  var openers = Array.prototype.slice.call(drawer.querySelectorAll('[data-mobile-submenu-open]'));
  var panels = Array.prototype.slice.call(drawer.querySelectorAll('[data-mobile-submenu]'));
  var drawerOpeners = Array.prototype.slice.call(document.querySelectorAll('[data-mobile-drawer-open]'));
  var activeTrigger = null;
  var lastDrawerTrigger = null;

  function resetGroup(groupToggle) {
    var expanded = groupToggle.getAttribute('aria-expanded') === 'true';
    if (!expanded) return;
    groupToggle.click();
  }

  function showRoot(options) {
    var restoreFocus = !options || options.restoreFocus !== false;

    panels.forEach(function (panel) {
      panel.hidden = true;
      panel.scrollTop = 0;
      panel.querySelectorAll('[data-mobile-group-toggle]').forEach(resetGroup);
    });
    openers.forEach(function (opener) {
      opener.setAttribute('aria-expanded', 'false');
    });
    if (root) {
      root.hidden = false;
      root.scrollTop = 0;
    }

    if (restoreFocus && activeTrigger) activeTrigger.focus({ preventScroll: true });
    activeTrigger = null;
  }

  function showPanel(trigger) {
    var panel = document.getElementById(trigger.getAttribute('data-mobile-submenu-open'));
    if (!panel || !root) return;

    activeTrigger = trigger;
    root.hidden = true;
    panels.forEach(function (item) { item.hidden = item !== panel; });
    openers.forEach(function (opener) {
      opener.setAttribute('aria-expanded', opener === trigger ? 'true' : 'false');
    });
    panel.scrollTop = 0;

    var back = panel.querySelector('[data-mobile-submenu-back]');
    if (back) back.focus({ preventScroll: true });
  }

  openers.forEach(function (trigger) {
    trigger.addEventListener('click', function () { showPanel(trigger); });
  });

  drawer.querySelectorAll('[data-mobile-submenu-back]').forEach(function (button) {
    button.addEventListener('click', function () { showRoot(); });
  });

  drawer.querySelectorAll('[data-mobile-group-toggle]').forEach(function (button) {
    button.addEventListener('click', function () {
      var expanded = button.getAttribute('aria-expanded') === 'true';
      var group = document.getElementById(button.getAttribute('aria-controls'));
      if (!group) return;

      group.querySelectorAll('.mobile-submenu-group__extra').forEach(function (item) {
        item.hidden = expanded;
      });
      button.setAttribute('aria-expanded', expanded ? 'false' : 'true');
      button.childNodes[0].nodeValue = (expanded ? button.dataset.moreLabel : button.dataset.lessLabel) + ' ';
    });
  });

  drawerOpeners.forEach(function (button) {
    button.addEventListener('click', function () {
      if (drawer.getAttribute('aria-hidden') === 'true') lastDrawerTrigger = button;
    }, true);
  });

  document.addEventListener('keydown', function (event) {
    if (drawer.getAttribute('aria-hidden') === 'true') return;

    if (event.key === 'Escape') {
      if (activeTrigger) {
        event.preventDefault();
        showRoot();
      } else if (typeof window.setMobileDrawer === 'function') {
        event.preventDefault();
        window.setMobileDrawer(false);
      }
      return;
    }

    if (event.key !== 'Tab') return;
    var focusable = Array.prototype.slice.call(drawer.querySelectorAll('a[href], button:not([disabled]), input:not([disabled]), [tabindex]:not([tabindex="-1"])'))
      .filter(function (item) { return !item.closest('[hidden]'); });
    if (!focusable.length) return;

    var first = focusable[0];
    var last = focusable[focusable.length - 1];
    if (event.shiftKey && document.activeElement === first) {
      event.preventDefault();
      last.focus();
    } else if (!event.shiftKey && document.activeElement === last) {
      event.preventDefault();
      first.focus();
    }
  });

  new MutationObserver(function () {
    var isOpen = drawer.getAttribute('aria-hidden') === 'false';
    if (isOpen) {
      if (!activeTrigger) showRoot({ restoreFocus: false });
    } else {
      showRoot({ restoreFocus: false });
      if (lastDrawerTrigger) lastDrawerTrigger.focus({ preventScroll: true });
    }
  }).observe(drawer, { attributes: true, attributeFilter: ['aria-hidden'] });
})();
